import { mapTo } from "rxjs/operators";
import { combineEpics, ofType } from "redux-observable";
import { push } from "connected-react-router";
import actionCreators from "./actionCreators";

const pushErrorPageEpic = action$ =>
    action$.pipe(ofType(actionCreators.errorPageRedirect.type), mapTo(push(`/error`)));

const pushMaintenancePageEpic = action$ =>
    action$.pipe(ofType(actionCreators.maintenancePageRedirect.type), mapTo(push(`/maintenance`)));

export const epics = combineEpics(pushErrorPageEpic, pushMaintenancePageEpic);
